var data = 
{
    title: 'What should you be looking at?',
    points: 
        [
            {
                subtitle: 'Revenue',
                subpoints:
                    [
                        {
                            texts: 
                                [
                                    'Track your revenues meticulously. Keeping an eye out for emerging trends in your revenue flows over time can help ensure you develop a data-based understanding of the demand for your products. '
                                ],
                            links: 
                                [
                                    {
                                        text: "LEARN MORE ABOUT REVENUE",
                                        link: 'https://www.fool.com/knowledge-center/how-to-calculate-total-revenue-growth-in-accountin.aspx'
                                    }
                                ]
                        },
                        {
                            equation: 
                                {
                                    int: 'Income from customers - (Merchandise Returns + Undeliverable Merchandise)'
                                }
                        },
                        {
                            texts:
                                [ 
                                    '<div class="boxed">Illustrative example: </div>If Mike’s Bikes notices that revenues are surging due to a particular type of bike selling well during July, he could plan to have more of those bikes in stock ahead of next July to maximize his sales. This helps Mike differentiate between what his customers have been telling him they want to buy and what they’re actually buying. With any luck, both point him in the same direction - but now he doesn’t need to have any anxiety about his intuition.'
                                ]
                        }
                    ]
            },
            {
                subtitle: 'Cost of Goods Sold (COGS)',
                subpoints: 
                    [
                        {
                            texts: 
                                [
                                    'Cost of Goods Sold refers to the cost required to produce all the items you sell. What’s tricky is what you include in your COGS number. Ultimately, it’s a number to help guide your decision-making, so think carefully about what COGS means for your business before you settle on a formula. '
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT COGS',
                                        link: 'https://www.thebalance.com/how-to-calculate-cost-of-goods-sold-397501'
                                    }
                                ]
                        },
                        {
                            equation: 
                                {
                                    int: 'Beginning Inventory + Built or Purchased Inventory - End Inventory'
                                }
                        },
                        {
                            texts:
                                [
                                    '<div class="boxed">Illustrative example: </div>If you sell 1 bikes for $100 and the cost to acquire the bike is 50$, your COGS would be $100. Some businesses, like a bike shop, could reasonably include raw materials alone, others shipping costs, and others could even include selling costs.'    
                                ]
                        }
                    ]
            },
            {
                subtitle: 'EBITDA (Earnings before Interest, Tax, Depreciation & Amortization)',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'EBITDA gives owners a view of their operating costs incurred in the normal course of business (i.e., cash in, cash out), and excludes important but potentially misleading non-cash expenses like depreciation.'
                                ]
                        },
                        {
                            texts: 
                                [
                                    'This number is also helpful if you pay any loan interest, which can often mask important cash flow issues.'
                                ]
                        },
                        {
                            texts:
                                [
                                    '<div class="boxed">Illustrative example: </div> Take 2 companies with net income of $100. Company A has EBITDA of $200 and interest of $100. Company B has EBITDA of $100 and interest of $0. We can say that although both companies have the same net income, Company A’s business activities earn more than Company B’s. Download our <a class="link" href="files/EBITDA_Template.xlsx" download>template</a>, we’ve done the math for you. 😉'
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT EBITDA',
                                        link: 'https://quickbooks.intuit.com/r/finding-funding/what-is-ebitda-and-how-can-your-company-use-it/'
                                    }
                                ]
                        }
                    ]
            },
            {
                subtitle: 'Net Income',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'Your net income gives is a measure of profit, after all of your cash and non-cash expenses (like depreciation) have been taken into account. As a result, remember that your net income won’t necessarily match the figures in your bank account. '
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT NET INCOME',
                                        link: 'https://www.accountingtools.com/articles/what-is-the-net-income-formula.html'
                                    }
                                ]
                        },
                        {
                            texts:
                            [
                                'What is this depreciation we speak of? Net income includes large purchases of assets that will help the business grow. A car, expensive piece of machinery, or even furniture fall into this category. They help your business earn revenues over many years  and so their cost can be reasonably allocated (or… depreciated) over the course of those same years, even if the payment terms with your supplier don’t match that schedule.'
                            ]
                        },
                        {
                            texts:
                            [
                                '<div class="boxed">Illustrative example: </div>If a car is expected to be useful for 10 years, the car purchase will show on the income statement, but not all at once. Rather, 1/10th of the cost will show up in expenses over each of the next 10 years - this is depreciation! You probably paid for the car up-front or leased it over a few years, but that is not reflective of how the car will help you over the life of your business. If you want to understand how the car impacted your cash on hand, you’ll have to dive into your company’s free cash flow!'
                            ]
                        }
                    ]
            },
            {
                subtitle: 'Abnormal Costs',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    
                                    'There are unforeseen costs that occur in any business. When planning for next year, it’s good to consider any unexpected costs that occurred during the year to make sure you are planning accordingly.'
                                ]
                        },
                        {
                            texts:
                                [
                                    ' A great way to know if an abnormal cost is “abnormal” is to ask yourself: “Am I expecting this cost to happen again next year”? 😏'
                                ]
                        },
                        {
                            texts:
                                [
                                    
                                    'It’s important to be honest with yourself here. If an abnormal cost keeps on popping up, you may need to accept that it isn’t that abnormal after all. Planning for these costs will help you better manage your company’s financial health, rather than thinking they’re always exceptions and scrambling to manage their impact.'
                                ]
                        },
                        {
                                links:
                                    [
                                        {
                                            link: 'http://www.investopedia.com/articles/investing/042413/financial-statement-extraordinary-vs-nonrecurring-items.asp'
                                        }
                                    ]
                        }
                    ]
            },
            {
                subtitle: 'Days Receivables (aka Days Sales Outstanding)',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    '“Days receivables” tells you how long it takes for customers to pay you and if your cash flow is healthy enough to cover purchases of inventory!'
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Account Receivables',
                                    denom: 'Credit Sales',
                                    int: 'x # of days in time period considered'
                                }
                        },
                        {
                            texts:
                                [
                                    '<div class="boxed">Illustrative example: </div>If Mike’s Bikes has account receivables of $3,000, and credit sales of $30,000 during the year (365 days); his “days receivable” is roughly 37 days ($3,000/$30,000 x 365). This means that, on average, it takes Mike roughly 37 days to get money from his customers who pay on credit!'
                                ],
                            links:
                                [
                                    {
                                        text: "LEARN MORE ABOUT DAYS RECEIVABLES",
                                        link: 'http://www.myaccountingcourse.com/financial-ratios/days-sales-outstanding'
                                    }
                                ]
                        }
                    ]
            },
            {
                subtitle: 'Inventory',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'It costs money to store products :package: and insure them. Too much inventory can cause your costs to rise as you not only need to pay to store them somewhere but you also risk them becoming old and less valuable to future clients.'
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT INVENTORY',
                                        link: 'https://www.accountingcoach.com/inventory-and-cost-of-goods-sold/explanation/6'
                                    }
                                ]
                        },
                        {
                            texts:
                                [
                                    'Conversely, not enough inventory can result in missing out on sales due to customers being unable to buy from you. Don’t leave money on the table!'
                                ]
                        },
                        {
                            texts:
                                [
                                    'It is important to keep track of inventory data over time to ensure that you’re making the an informed decision about how much inventory you actually need to buy based on how much you typically sell and the realistic cost to store it.'
                                ]
                        },
                        {
                            texts:
                                [
                                    'Special note for SaaS companies: Lucky you. You don’t have any inventory to worry about. Don’t rub it in our faces 😡...'
                                ]
                        }
                    ]
            },
             {
                subtitle: 'Days Inventory Outstanding (DIO)',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'Days Inventory Outstanding indicates how long it takes to sell your entire inventory! Looking at this number over time can give you a sense of whether or not you are making appropriate inventory purchasing decisions.'
                                ]
                        },
                        {
                            texts:
                                [
                                    'Note that a low number is generally preferred, but it is important to compare this number to others in your industry and your historical data.'
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Value of Inventory',
                                    denom: 'Cost of Goods Sold',
                                    int: 'x 365 days'
                                }
                        },
                        {
                            texts:
                                [
                                    '<div class="boxed">Illustrative example: </div>Let’s look at Mike’s Bikes. Mike has a $5,000 worth of inventory and $25,000 of Cost of Goods Sold. Therefore Mike’s Days Inventory Outstanding is 73 days! This means, on average, it takes Mike 73 days to sell off his entire inventory. Most shops in his area have a DIO number of around 45 days. Mike may be buying too much inventory.'
                                ],
                            links:
                                [
                                    {
                                        text: "LEARN MORE ABOUT DAYS INVENTORY OUTSTANDING",
                                        link: 'https://strategiccfo.com/days-inventory-outstanding/'
                                    }
                                ]
                        }    
                    ]
            },
            {
                subtitle: 'Days Payable Outstanding (DPO)',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'Tracking this number  is a great way to check if you are paying back your vendors too quickly or too slowly. Most medium size companies tend to have Days Payables of 30 days, but smaller companies will likely have a much lower number. The best possible case is to have a DPO as high as possible, while keeping your suppliers happy 🤗'
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT DAYS PAYABLE OUTSTANDING',
                                        link: 'https://www.satago.com/blog/how-to-calculate-days-payable-outstanding'
                                    }
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Value of Accounts Payable',
                                    denom: 'Cost of Good Sold',
                                    int: 'x # of days in time period considered'
                                }
                        },
                        {
                            texts:
                                [
                                    "<div class='boxed'>Illustrative example: </div>Mike's Bikes bought $15,000 worth of bikes part from Pat’s Parts and Mike’s COGS sold was $150,000 for the year. His DPO would be 37 days (15000/150000 * 365 = ~37). This means that, on average, Mike takes 37 days to pay back his vendors. Going forward Mike should make sure he is paying back his vendors within their 30 day timelines to ensure that he maintains a healthy business relationship and incurs no penalties!"
                                ]
                        }
                    ]
            },
            {
                subtitle: 'Quick Ratio',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'Sometimes you might need to pay things off quickly. It’s important to know just how much you could pay in short order at any given point in time. You may not realize just how much of your money is tied up in hard to sell assets, like a machine. That’s why you want to know your “Quick Ratio”.'
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT QUICK RATIOS',
                                        link: 'http://www.accountingformanagement.org/quick-ratio-or-acid-test-ratio/'
                                    }
                                ]
                        },
                        {
                            texts: 
                                [
                                    "This metric gives a sense of your company's ability to pay back debts and accounts payable with <ins>current assets</ins> such as cash, short-term investments, and account receivable. It excludes inventory because many experts  see inventory as something that cannot quickly be sold off unlike other current assets. This ratio should be above 1, but do not panic if it falls below as it does not imply you will go bankrupt."
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Value of Current Assets - Value of Inventory',
                                    denom: 'Current Liabilities (i.e. debt, payables)'
                                }
                        }
                    ]
            },
            {
                subtitle: 'Debt to Total Assets (Debt Ratio)',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'As a small business it is likely you will take on loans to buy assets that will help grow your business. It is it important to make sure you are not over-borrowing.'
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT DEBT TO TOTAL ASSETS RATIO',
                                        link: 'https://www.thebalance.com/debt-to-asset-ratio-393193'
                                    }
                                ]
                        },
                        {
                            texts:
                                [
                                    'In order to keep track of how much debt you’re accumulating use the debt to asset ratio. The higher the debt to asset ratio, the riskier your business becomes. That’s because most businesses could ultimately sell off assets to pay off debts. If you have more debts than assets, you increase your risk profile.'
                                ]
                        },
                        {
                            texts:
                                [
                                    'In most scenarios, it’s best to try and keep this as low as possible to avoid having too much risk. Once again, compare to industry peers to see if you are within acceptable limits.'
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Total Value of Debt',
                                    denom: 'Total Value of Assets'
                                }
                        }
                    ]
            },
            {
                subtitle: 'Gross Margin',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'The general margin tells you how much money you earn on every dollar of a product sold. A great idea is setting goals to improve this margin every year by improving the pricing you receive from your suppliers and increasing the price your customers are willing to pay! 🙂'
                                ],
                            links:
                                [
                                    {
                                        text: 'LEARN MORE ABOUT GENERAL MARGIN',
                                        link: 'http://www.investopedia.com/terms/g/grossmargin.asp'
                                    }
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Revenue - Cost of Goods Sold',
                                    denom: 'Revenue'
                                }
                        }
                    ]
            },
            {
                subtitle: 'Net Profit Margin',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'Simple to calculate and a great way to see how much net profit you are earning for each dollar of revenue. Similar to the gross margin, it is a good idea to set goals to grow this number every year. Unlike gross margin, this metric looks at the cost of operating your business and paying interest on debts and taxes rather than the cost of goods itself.'
                                ],
                            links:
                                [
                                    {
                                        text: "LEARN MORE ABOUT NET PROFIT MARGIN",
                                        link: 'http://smallbusiness.chron.com/net-profit-margin-equation-18786.html'
                                    }
                                ]
                        },
                        {
                            equation: 
                                {
                                    num: 'Net Profit',
                                    denom: 'Revenue'
                                }
                        }
                    ]
            }
        ]
}

module.exports = data;

/* TEMPLATE
{
    title: 'TEXT',
    points:
        [
            {
                subtitle: 'TEXT',
                subpoints:
                    [
                        {
                            texts:
                                [
                                    'TEXT'
                                ],
                            links:
                                [
                                    {
                                        text: 'TEXT',
                                        link: 'URL'
                                    }
                                ],
                            equation: 
                                {
                                    num: 'TEXT',
                                    denom: 'TEXT',
                                    int: 'TEXT'
                                }
                        }
                    ]
            }
        ]
}
*/

//   /!\ Links are always displayed after all of the text components, regardless of where you put it in the subpoints array. /!\


// WEBPACK FOOTER //
// src/content/checklistContent.js